import React from 'react';
import ProfileUpper from './ProfileUpper';
import ProfileIntegrations from './ProfileIntegrations';

const ProfileLeft = ({loading, userData }) => {
  return (
    <div className="profile-left">
      <ProfileUpper loading={loading} userData={userData} />
      <ProfileIntegrations loading={loading} userData={userData} />
    </div>
  );
};

export default ProfileLeft;
